// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["assets/css/style-admin","style"], () => (__webpack_require__("./resources/scripts/scripts.js")))
__webpack_require__.O(undefined, ["assets/css/style-admin","style"], () => (__webpack_require__("./resources/scss/style.scss")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["assets/css/style-admin","style"], () => (__webpack_require__("./resources/scss/style-admin.scss")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
